import { render, staticRenderFns } from "./consume-record-dialog.vue?vue&type=template&id=dec7e222&scoped=true"
import script from "./consume-record-dialog.vue?vue&type=script&lang=ts"
export * from "./consume-record-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec7e222",
  null
  
)

export default component.exports